<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="card-title">
          <h2>
            출석일 설정
          </h2>
          <p class="gray">클래스 출석 관리 대상 일자를 설정합니다.</p>
        </div>
      </div>
    </div>
    <div class="card second-card">
      <div class="card-body calendar-header">
        <div class="d-flex">
          <div class="p-0">
            <button type="button" class="btn btn-primary" @click="moveCalAction('today')">오늘</button>
            <button type="button" class="btn circle" @click="moveCalAction('prev')">&lt;</button>
            <span class="calendar-title">{{calendarMonth}}</span>
            <button type="button" class="btn circle" @click="moveCalAction('next')">&gt;</button>
          </div>
          <div class="ml-auto p-0">
            <button type="button" class="btn grey" @click="retrieve">취소</button>
            <button type="button" class="btn mint" @click="registerSchedule">저장</button>
          </div>
        </div>
      </div>
      <div class="card-body calendar">
        <calendar ref="tuiCalendar" :style="calendarStyle"
          :calendars="calendarList"
          :schedules="scheduleList"
          :view="view"
          :taskView="taskView"
          :scheduleView="scheduleView"
          :theme="theme"
          :week="week"
          :month="month"
          :timezones="timezones"
          :disableDblClick="disableDblClick"
          :isReadOnly="isReadOnly"
          :template="template"
          :useCreationPopup="useCreationPopup"
          :useDetailPopup="useDetailPopup"
          @clickSchedule="onClickSchedule"
          @beforeCreateSchedule="onBeforeCreateSchedule">
        </calendar>
      </div>
    </div>

  </div>
</template>

<script>
import 'tui-calendar/dist/tui-calendar.css'
import { Calendar } from '@toast-ui/vue-calendar'
import common from '@/modules/common'
export default {
  name: 'M020105',
  mixins: [common.mixins],
  components: {'calendar': Calendar},
  data () {
    return {
      calendarStyle: 'height: ' + this.getScreenHeight(17) + 'px;',
      calendarList: [
        {
          id: '1',
          name: 'oliver',
          color: '#00aec0',
          bgColor: '#00aec0',
          dragBgColor: '#00aec0',
          borderColor: '#00aec0'
        },
        {
          id: '2',
          name: 'oliver2',
          color: '#fcc5c9',
          bgColor: '#fcc5c9',
          dragBgColor: '#fcc5c9',
          borderColor: '#fcc5c9'
        }
      ],
      scheduleList: [],
      view: 'month',
      taskView: false,
      scheduleView: ['allday'],
      theme: {
        'common.border': '1px solid #e5e5e5',
        'common.backgroundColor': 'white',
        'common.holiday.color': '#ff4040',
        'common.saturday.color': '#333',
        'common.dayname.color': '#333',
        'common.today.color': '#333',
        // creation guide style
        'common.creationGuide.backgroundColor': 'rgba(81, 92, 230, 0.05)',
        'common.creationGuide.border': '1px solid #515ce6',
        // month header 'dayname'
        'month.dayname.height': '42px',
        'month.dayname.borderLeft': '1px solid #e5e5e5',
        'month.dayname.paddingLeft': '10px',
        'month.dayname.paddingRight': '10px',
        'month.dayname.backgroundColor': 'inherit',
        'month.dayname.fontSize': '14px',
        'month.dayname.fontWeight': 'normal',
        'month.dayname.textAlign': 'center',
        // month day grid cell 'day'
        'month.holidayExceptThisMonth.color': 'rgba(255, 64, 64, 0.4)',
        'month.dayExceptThisMonth.color': 'rgba(51, 51, 51, 0.4)',
        'month.weekend.backgroundColor': 'inherit',
        'month.day.fontSize': '14px',
        // month schedule style
        'month.schedule.borderRadius': '2px',
        'month.schedule.height': '24px',
        'month.schedule.marginTop': '2px',
        'month.schedule.marginLeft': '8px',
        'month.schedule.marginRight': '8px'
      },
      week: {
        narrowWeekend: true,
        showTimezoneCollapseButton: true,
        timezonesCollapsed: false
      },
      month: {
        daynames: ['일', '월', '화', '수', '목', '금', '토'],
        startDayOfWeek: 0,
        narrowWeekend: false,
        isAlways6Week: false
      },
      timezones: [{
        timezoneOffset: 540,
        displayLabel: 'GMT+09:00',
        tooltip: 'Seoul'
      }],
      disableDblClick: true,
      isReadOnly: false,
      template: {
        milestone: function (schedule) {
          return `<span style="color:red;">${schedule.title}</span>`
        },
        milestoneTitle: function () {
          return 'MILESTONE'
        }
      },
      useCreationPopup: false,
      useDetailPopup: false,
      calendarMonth: ''
    }
  },
  beforeCreate () {
    if (this.$route.params.class_seq === undefined || this.$route.params.class_seq === 0) {
      this.$router.push({name: 'M020101'})
    }
  },
  created () {
  },
  mounted () {
    this.setRenderRangeText()
  },
  methods: {
    retrieve () {
      const param = {
        class_seq: this.$route.params.class_seq,
        from_dt: this.getCalendarDate('getDateRangeStart'),
        to_dt: this.getCalendarDate('getDateRangeEnd')
      }
      common.axios.post('/class/attendance/schedule/load', param)
        .then(response => {
          const result = response.data
          // console.log(result)
          const list = []
          result.map(item => {
            const schedule = {
              id: item.attendance_dt,
              calendarId: item.attendance_count > 0 ? '2' : '1',
              title: '출석',
              category: 'allday',
              dueDateClass: '',
              isAllDay: true,
              start: item.attendance_dt,
              end: item.attendance_dt
            }
            list.push(schedule)
          })
          this.scheduleList = list
        })
    },
    registerSchedule () {
      if (this.scheduleList.length === 0) {
        this.$message.warning('출석 관리 일정을 선택하십시오.')
        return
      }
      const param = {
        class_seq: this.$route.params.class_seq,
        schedule: this.scheduleList.map(x => x.id).sort(),
        from_dt: this.getCalendarDate('getDateRangeStart'),
        to_dt: this.getCalendarDate('getDateRangeEnd')
      }
      // console.log('param : ', param)
      common.axios.post('/class/attendance/schedule/storage', param)
        .then(response => {
          console.log(response.data)
          if (response.data.status === 1) {
            this.$message('저장되었습니다.')
            this.retrieve()
          }
        })
    },
    onClickDayname (e) {
      console.log('onClickDayname : ', e)
    },
    onClickSchedule (e) {
      // console.log('onClickSchedule : ', e)
      // 출석체크가 등록된 캘린더
      if (e.schedule.calendarId === '2') {
        this.$confirm('출석 체크가 등록된 일정을 삭제하시겠습니까?', '', {
        }).then(() => {
          const param = {
            class_seq: this.$route.params.class_seq,
            attendance_dt: e.schedule.id
          }
          common.axios.delete('/class/attendance/schedule', {data: param})
            .then(response => {
              // console.log(response.data)
              if (response.data.status === 1) {
                this.$message('삭제되었습니다.')
                this.retrieve()
              }
            })
        }).catch(() => {})
      }
    },
    onBeforeCreateSchedule (e) {
      // console.log('onBeforeCreateSchedule : ', e)
      const startDate = this.formatterDate(e.start._date, 'YYYYMMDD')
      const endDate = this.formatterDate(e.end._date, 'YYYYMMDD')
      const rangeDates = this.getDates(startDate, endDate)
      rangeDates.map(date => {
        const schedule = {
          id: date,
          calendarId: '1',
          title: '출석',
          category: 'allday',
          dueDateClass: '',
          isAllDay: true,
          start: date,
          end: date
        }
        // 동일한 날짜가 있는지 확인
        const index = this.scheduleList.findIndex(x => x.id === date)
        if (index !== -1) {
          // calendarId가 '2'인 것은 제외한다.
          const list = this.scheduleList.filter(x => x.id !== date || x.calendarId === '2')
          this.scheduleList = list
        } else {
          this.scheduleList.push(schedule)
        }
      })
      e.guide.clearGuideElement()
    },
    moveCalAction (action) {
      this.$refs.tuiCalendar.invoke(action)
      this.$nextTick(() => {
        this.setRenderRangeText()
      })
    },
    setRenderRangeText () {
      this.calendarMonth = this.getCalendarDate('getDate', 'YYYY.MM')
      this.$nextTick(() => {
        this.retrieve()
      })
    },
    getCalendarDate (method, format = 'YYYYMMDD') {
      return this.formatterDate(this.$refs.tuiCalendar.invoke(method).toDate(), format)
    }
  }
}
</script>

<style scoped>
  .card-body.calendar-header, .card-body.calendar {
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .calendar-header .btn.circle {
    margin-left: 10px;
    margin-right: 10px;
    font-size: 20px;
    color: #777;
  }
  .calendar-title {
    font-size: 18px;
    font-weight: bold;
    margin-top: 8px;
    display: inline-block;
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/pages/M020105.vue